import { compose, filter, isEmpty, isNil, map, not, path, pathOr } from 'ramda'

export default {
  /**
   * getOffer
   *
   * @param { String } identifier Offer identifier. If it is numeric (All
   *   characters match regex /\d/) then lookup offer by ID. Otherwise lookup
   *   offer by share key
   * @returns { Offer } offer
   */
  getOffer: (state) => (identifier) => {
    if (/^\d+$/.test(identifier)) {
      const offerId = parseInt(identifier, 10)
      return state.offers[offerId]
    }
    return Object.values(state.offers).find(({ shareKey }) => (
      shareKey === identifier
    ))
  },

  /**
   * Gets a list of offer lines on a per-offer basis that are not associated with a section.
   *
   * @type {function}
   * @param {Object} state
   * @returns {{Array}} Offer lines mapped to offer ID.
   */
  linesWithoutSectionByOffer: compose(
    map(
      compose(
        filter(compose(isNil, path(['sectionId']))),
        pathOr([], ['offerLines']),
      ),
    ),
    filter(compose(not, isEmpty, path(['sections']))),
    path(['offers']),
  ),
}
